module.exports = __webpack_public_path__ + "img/what9.a1959d38.png";